import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BackAnchor from '../../../../shared/components/BackAnchor'
import Address from './Address'
import styles from './ContactInformation.module.scss'
import EmailAddress from './EmailAddress'
import FullName from './FullName'
import PhoneNumber from './PhoneNumber'

const ContactInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()

  const [addressUpdated, setAddressUpdated] = useState('')

  const [fullNameValid, setFullNameValid] = useState('')
  const [emailAddressValid, setEmailAddressValid] = useState('')
  const [phoneNumberValid, setPhoneNumberValid] = useState('')
  const [addressUpdateValid, setAddressUpdateValid] = useState('')

  const [addressUpdateError] = useState('contact_info.address_update_error')
  const [fullNameError, setFullNameError] = useState('contact_info.full_name_error')
  const [emailAddressError, setEmailAddressError] = useState('contact_info.email_address_error')
  const [phoneNumberError, setPhoneNumberError] = useState('contact_info.phone_number_error')

  const { fullName, emailAddress, phoneNumber, permits } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      if (permits.length === 0) {
        history.push(`/${i18n.language}${t('routes.your_info')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const onNext = () => {
    try {
      if (validateFields()) {
        history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      let fullNameValid = false,
        emailAddressValid = false,
        phoneNumberValid = false,
        addressUpdateValid = false
      if (fullName === '') {
        setFullNameValid(fullNameValid)
      } else {
        fullNameValid = validateFullName(fullName)
      }
      if (emailAddress === '') {
        setEmailAddressValid(emailAddressValid)
      } else {
        emailAddressValid = validateEmailAddress(emailAddress)
      }
      if (phoneNumber === '') {
        setPhoneNumberValid(phoneNumberValid)
      } else {
        phoneNumberValid = validatePhoneNumber(phoneNumber)
      }
      if (addressUpdated === '') {
        setAddressUpdateValid(addressUpdateValid)
      } else {
        addressUpdateValid = true
      }
      return fullNameValid && emailAddressValid && phoneNumberValid && addressUpdateValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFullName = (name) => {
    try {
      let fullNameValid = false,
        fullNameError = ''
      const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ()&-,.' ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          if (name.length > 1) {
            fullNameValid = true
          } else {
            fullNameError = 'contact_info.full_name_error_less_characters'
          }
        } else {
          fullNameError = 'contact_info.full_name_error_invalid'
        }
      } else {
        fullNameError = 'contact_info.full_name_error'
      }
      setFullNameValid(fullNameValid)
      setFullNameError(fullNameError)
      return fullNameValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateEmailAddress = (email) => {
    try {
      let emailValid = false,
        emailValidError = ''
      const regex = RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      if (email.length > 0) {
        if (regex.test(email)) {
          emailValid = true
        } else {
          emailValidError = 'contact_info.email_address_error_invalid'
        }
      } else {
        emailValidError = 'contact_info.email_address_error'
      }
      setEmailAddressValid(emailValid)
      setEmailAddressError(emailValidError)
      return emailValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePhoneNumber = (number) => {
    try {
      let phoneValid = false,
        phoneValidError = ''
      if (number.length > 0) {
        if (number.length === 12) {
          phoneValid = true
        } else {
          phoneValidError = 'contact_info.phone_number_error_invalid'
        }
      } else {
        phoneValidError = 'contact_info.phone_number_error'
      }
      setPhoneNumberValid(phoneValid)
      setPhoneNumberError(phoneValidError)
      return phoneValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <BackAnchor
            backPath={
              localStorage.getItem('requiresInsurance') === 'true'
                ? 'routes.insurance_info'
                : permits.length === 1
                ? 'routes.your_info'
                : 'routes.add_permit'
            }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{t('contact_info.give_your')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <FullName
            validateFullName={validateFullName}
            fullNameError={fullNameError}
            fullNameValid={fullNameValid}
            setIsError={setIsError}
          />
          <EmailAddress
            validateEmailAddress={validateEmailAddress}
            emailAddressError={emailAddressError}
            emailAddressValid={emailAddressValid}
            setIsError={setIsError}
          />
          <PhoneNumber
            validatePhoneNumber={validatePhoneNumber}
            phoneNumberError={phoneNumberError}
            phoneNumberValid={phoneNumberValid}
            setIsError={setIsError}
          />
          <Address
            addressUpdateError={addressUpdateError}
            setAddressUpdated={setAddressUpdated}
            setAddressUpdateValid={setAddressUpdateValid}
            addressUpdateValid={addressUpdateValid}
          />
        </div>
      </div>
      <div className={styles['back_next_margin']}>
        <button style={{ margin: 0 }} className="btn-lg btn-primary" onClick={onNext}>
          {t('shared.next_step')}
        </button>
      </div>
    </div>
  )
}

export default withTranslation('common')(ContactInformationView)
